<template>
<div>
<nav class="navbar navbar-expand-md navbar-dark bg-primary">
      <router-link :to="{ name : 'ResumenNegocio' }">
         <img src="@/assets/css/content-layout/assets/img/nuevo-capital.svg" width="120" height="60" class="d-inline-block align-top" alt="Nuevo Capital"></router-link>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
         <ul class="navbar-nav ml-auto">
            <li class="nav-link moneda">UF: {{uf}}</li>
            <li class="nav-link moneda">DÓLAR: {{dolar}}</li>
            <li class="nav-item">
               <a class="nav-link" href="#top"><span class="fa fa-user"></span> {{useraccess}}</a>
            </li>
            <li class="nav-item">
               <a class="nav-link" href="#top" @click="CerrarSesion()"><span class="fa fa-lock"></span> Cerrar sesión</a>
            </li>
            <li class="nav-item">
               <a class="nav-link" href="#top" @click="showObs">
				   <span class="fa fa-bell">
					<span :class="{'badge':this.testimonios.length>0 , 'badge2':this.testimonios.length===0}">{{this.testimonios.length}}
					</span>
				   </span>
				</a>
            </li>
         </ul>
      </div>
	  <!--Notificacion-->
		<div class="container-observacion" id="myForm" v-if="observaciones">
		<span  v-if="testimonios.length>0"></span>
		<span class="notification-vacia" v-else>Sin Notificaciones</span>
			<div class="container-noti">
				<div class="box-notification" v-for="(t, index) in testimonios" v-bind:key="index">
					<p><span>{{t.nombre}} {{t.hora_recepcion}} <br> {{t.estado_resumen}}:{{t.tipo_movimiento}}</span>
					<router-link :to="{ name : 'LinkNegocio', params: { credito: t.idLeasing_credito, empresa: t.rut }  }"><br>IDº {{t.idLeasing_credito}}</router-link>
					</p>
				</div>
			</div>
		</div>
		<!--End Notificacion-->
</nav>

</div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
export default {
	name: 'Navbar',
	methods: {
		...mapActions([
			'logout'
		]),
		CerrarSesion () {
			this.logout()
		},
		showObs () {
			if (this.observaciones) {
				this.observaciones = false
			} else {
				this.observaciones = true
			}
		}
	},
	mounted () {
		if (!this.accessToken) this.$router.push('Login')
		const auth = {
			headers: { 'Authorization': this.accessToken }
		}
		this.axios.post(this.apiurl + 'Testimonios/getTestimoniosRelevo', {}, auth).then(response => {
			if (response.data.token !== this.accessToken) {
				this.logout()
			}
			this.testimonios = response.data.testimonios
		}).catch(error => {
			if (error.response.data.token !== this.accessToken) { this.logout() }
			// alert(error.response.data.mensaje)
			this.isLoading = false
		})
		var currentDateWithFormat = new Date().toJSON().slice(0, 10)
		var res = currentDateWithFormat.split('-')
		this.axios.get('https://mindicador.cl/api/uf/' + res[2] + '-' + res[1] + '-' + res[0], {}, auth).then(response => {
			this.uf = response.data.serie[0].valor
		}).catch(error => {
			 alert(error.response.data)
		})
		this.axios.get('https://mindicador.cl/api/dolar/' + res[2] + '-' + res[1] + '-' + res[0], {}, auth).then(response => {
			this.dolar = response.data.serie[0].valor
		}).catch(error => {
			 alert(error.response.data)
		})
	},
	data () {
		return {
			testimonios: [],
			observaciones: '',
			uf: 0,
			dolar: 0
		}
	},
	computed: {
		...mapState([
			'accessToken',
			'logginIn',
			'loginError', 'apiurl', 'useraccess'])
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue